import { isEmbroideryTrace } from '../config/appVariant';

export const CREDIT_TOP_UP_EVENT = 'embroidery-credit-top-up';

// True when the credit shop will explain this failure itself, so callers must not
// also raise their own error toast. Matches credit exhaustion specifically, never
// authentication, plan access, provider quota failures, or a generic HTTP 402.
export function creditTopUpHandles(error) {
  if (!isEmbroideryTrace) return false;
  const body = error?.response?.data;
  const message = typeof error === 'string' ? error : body?.message || body?.error || error?.message;
  return typeof message === 'string' && (
    message === 'No AI credits remaining.' ||
    message.startsWith('You have used your AI credits.')
  );
}

export function offerCreditTopUp(error, tool) {
  if (!creditTopUpHandles(error)) return false;
  window.dispatchEvent(new CustomEvent(CREDIT_TOP_UP_EVENT, {detail: {tool}, cancelable: true}));
  return true;
}
